// src/ProgressBar.tsx
import React from "react";
import "./index.css";

interface ProgressBarProps {
  progress: number;
}

const ProgressBarCustom: React.FC<ProgressBarProps> = ({ progress }) => {
  const getColor = (): string => {
    if (progress == 0) return "transparent";
    if (progress > 0 && progress < 50) return "#FCEEED";
    if (progress >= 50 && progress < 100) return "#FFEDC8";
    if (progress == 100) return "#E6F4ED";
    return "transparent";
  };

  const getTextColor = (): string => {
    if (progress == 0) return "#572AC8";
    if (progress > 0 && progress < 50) return "#B32306";
    if (progress >= 50 && progress < 100) return "#A17217";
    if (progress == 100) return "#07794C";
    return "#572AC8";
  };

  return (
    <div className="progress-bar-container">
      <div
        className="progress-bar"
        style={{
          width: progress == 0 ? "auto" : `${progress}%`,
          backgroundColor: getColor(),
          color: getTextColor(),
        }}
      >
        {progress == 0 ? "Yet to start" : progress + "% Complete"}
      </div>
    </div>
  );
};

export default ProgressBarCustom;
